module.exports = __webpack_public_path__ + "img/l_111.efb41adc.jpg";